var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.companydb_id)?_c('div',[_c('InvoiceablesListComponent',{attrs:{"companydb_id":_vm.companydb_id,"invoiceable_type":'budget'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }